export default [
  {
    name: 'dashboards',
    path: 'dashboards',
    component: () => import('@/views/dashboard/DashboardStartseite.vue'),
  },
  {
    path: 'qs-dashboard',
    component: () => import('@/layouts/qsdashboard/QsDashboardLayout.vue'),
    children: [
      {
        name: 'qs-dashboard',
        path: '',
        component: () => import('@/views/qsdashboard/QsDashboardStartseite.vue'),
      },
    ],
  },
];
